import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import NonHubSpotStatusPlaceholder from './NonHubSpotStatusPlaceholder';
const NonHubSpotStatusContainerLoadable = Loadable({
  // @ts-expect-error untyped dependency
  loader: () => import('./NonHubSpotStatusContainer'),
  LoadingComponent: NonHubSpotStatusPlaceholder
});
export default NonHubSpotStatusContainerLoadable;